export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export type BreakpointKey = keyof typeof breakpoints

/** Returns a max-width media query string, e.g. `(max-width: 767px)` */
export function maxWidth(key: BreakpointKey): string {
  return `(max-width: ${breakpoints[key] - 1}px)`
}

/** Returns a min-width media query string, e.g. `(min-width: 768px)` */
export function minWidth(key: BreakpointKey): string {
  return `(min-width: ${breakpoints[key]}px)`
}
